
'use strict';
import {Injectable, Inject} from 'ng-metadata/core';
import {IBreadcrumbs} from '../../infra/dataStructures/collections/breadcrumbs/breadcrumbs.interface';
import {Breadcrumbs} from '../../infra/dataStructures/collections/breadcrumbs/breadcrumbs.structure';
import {SeedData} from './citationTrailsBreadcrumbs.directive';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {SearchService} from '../search.service';
import {preventStateReload} from '../../infra/annotations';


const clone= require('lodash/clone');

@Injectable()
export class CitationTrailsBreadcrumbsService {
	private _seeds : IBreadcrumbs<SeedData>;
	public CITATION_TRAILS_STATE = STATE_NAMES.CITATION_TRAILS;

	constructor(@Inject('$state') private $state: ng.ui.IStateService,
				@Inject('$location') private $location:ng.ILocationService,
				private searchService: SearchService) {
		this._seeds = new Breadcrumbs<SeedData>();
	}

	get seeds() : IBreadcrumbs<SeedData> {
		return this._seeds;
	}
	set seeds(seeds:IBreadcrumbs<SeedData>){
		this._seeds = seeds;
	}

    
    public performCitationTrailsSearch(data){
        return this.searchService.performCitationTrailsSearch(data.facet)
    }
    
    @preventStateReload
    public updateURLSearchParams(data){
        let params= clone(data);
        params.seedInfo= null;
        this.$location.search(params);
    }    
}


//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrailsBreadcrumbs.service.ts